import Vue from 'vue'
import i18n from './index'

const getTranslation = new Vue({
  i18n,
  methods: {
    getTranslation(key) {
      if (key === 'IT服务/软件') key = 'IT服务_软件'
      if (key === '政府/事业单位') key = '政府_事业单位'
      return this.$t(key)
    }
  }
}).getTranslation

export default getTranslation
